import images from "./images";

const compositions = {
    sub: "mineral water",
    heading: "water Composition",
    items: [
        {
            symbol: 'Ca',
            name: 'calcium',
            value: '19.1 mg / L',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
        },
        {
            symbol: 'Mg',
            name: 'Magnesium',
            value: '2.5 mg / L',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
        },
        {
            symbol: 'Na',
            name: 'Sodium',
            value: '9.5 mg / L',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
        },
        {
            symbol: 'K',
            name: 'potassium',
            value: '0.5 mg / L',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
        },
        {
            symbol: 'HCO',
            name: 'Bicarbonate',
            value: '35 mg / L',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
        },
        {
            symbol: 'Cl-',
            name: 'Chloride',
            value: '12.1 mg / L',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
        }
    ],
    image: {
        src: images.composition,
        alt: "Water Compositions",
    },
};

export default compositions;